import React from 'react';

interface MarkerCircleProps {
  sizeAsText: string;
  isHovered: boolean;
  id?: string;
}

const MarkerCircle = ({
  sizeAsText,
  isHovered,
  id,
}: MarkerCircleProps) => {
  return (
    <div
      id={id}
      className={`w-full h-full rounded-full cursor-pointer flex items-center justify-center border-2 border-white animate-markerFade text-white ${
        isHovered ? 'bg-sky-600' : 'bg-purple-500 hover:bg-sky-600'
      }`}
    >
      {sizeAsText}
    </div>
  );
};

export default MarkerCircle;
